const countryTaxPlans = {
    IN: [
        {
            code: "NA",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 0
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 0
                }
            ]
        },
        {
            code: "IN-GST-A",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 2.5
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 2.5
                }
            ]
        },
        {
            code: "IN-GST-B",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 6
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 6
                }
            ]
        },
        {
            code: "IN-GST-C",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 9
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 9
                }
            ]
        },
        {
            code: "IN-GST-D",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 14
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 14
                }
            ]
        },
        {
            code: "IN-GST-E",
            components: [
                {
                    code: "CGST",
                    name: "Central GST",
                    rate: 14
                },
                {
                    code: "SGST",
                    name: "State GST",
                    rate: 14
                },
                {
                    code: "Cess",
                    name: "Central GST",
                    rate: 5
                }
            ]
        }
    ],
    GB: [
        {
            code: "NA",
            components: [
                {
                    code: "CVAT",
                    name: "Central VAT",
                    rate: 0
                },
                {
                    code: "STAX",
                    name: "Service Tax",
                    rate: 0
                }
            ]
        },
        {
            code: "GB-VAT",
            components: [
                {
                    code: "CVAT",
                    name: "Central VAT",
                    rate: 10
                },
                {
                    code: "STAX",
                    name: "Service Tax",
                    rate: 10
                }
            ]
        }
    ]
}
export const taxPlans = countryTaxPlans[process.env.VUE_APP_COUNTRY]